import React, { useState, useEffect } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import Calendar from 'react-calendar';
import { ToastContainer, toast } from 'react-toastify';
import '../../css/yemae.css';
// import "react-date-picker/dist/DatePicker.css";
// import "react-calendar/dist/Calendar.css";
import '../../css/calendar.css';
import axios from 'axios';
import moment from 'moment';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { Modal } from 'react-responsive-modal';
import { isMobile } from 'react-device-detect';

const Ticket = (props) => {
  const { history, imgUrl } = props;
  const _reserve = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // if (today < '2023-11-21 10:00:00') {
    //   toast.warn('예매가 시작전입니다.');
    //   return;
    // }

    if (today > '2024-01-07 18:00:00') {
      toast.warn('예매가 종료되었습니다.');
      return;
    }
    history.push('/reserve');
  };
  const _reserveList = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // if (today < '2023-11-21 10:00:00') {
    //   toast.warn('예매가 시작전입니다.');
    //   return;
    // }
    history.push('/reserveList');
  };
  const _onBack = () => {
    history.goBack();
  };
  return (
    <>
      <div>
        <div className="event_head">
          <h3>앙사블 스타즈!!! 3주년 전시회</h3>
          {isMobile && (
            <button
              type="button"
              className="btnClose"
              onClick={_onBack}
              style={{ pointer: 'cursor' }}
            >
              <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
            </button>
          )}
        </div>
        <div className="eventCon">
          {isMobile ? (
            <div className="event220916_2">
              <div>
                <img src={imgUrl + '/img/mediaArt/MOBILE_01.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/MOBILE_02.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/MOBILE_03.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/MOBILE_04.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/MOBILE_05_2.png'} />
                <a name="info"></a>
              </div>
              <div className="btm_bar" style={{ paddingRight: '3.6rem' }}>
                <div className="bar">
                  <img
                    src={imgUrl + '/img/mediaArt/M_BUTTON.png'}
                    usemap="#image-map1"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="event220916_2">
              <div>
                <img src={imgUrl + '/img/mediaArt/WEB_01.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/WEB_02.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/WEB_03.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/WEB_04.png'} />
              </div>
              <div>
                <img src={imgUrl + '/img/mediaArt/WEB_05_2.png'} />
                <a name="info"></a>
              </div>
              <div className="btm_bar" style={{ paddingRight: '3.6rem' }}>
                <div className="bar">
                  <img
                    src={imgUrl + '/img/mediaArt/BUTTON2.png'}
                    usemap="#image-map"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <map name="image-map1">
        <area
          onClick={() => {
            // history.push('/reserve');
            _reserve();
          }}
          alt="예매하기"
          title="예매하기"
          style={{ cursor: 'pointer' }}
          coords="168,132,610,52"
          shape="rect"
        />
        <area
          alt="전시정보"
          title="전시정보"
          href="#info"
          coords="277,221,44,155"
          shape="rect"
        />
        <area
          alt="예매정보"
          title="예매정보"
          onClick={() => {
            _reserveList();
          }}
          style={{ cursor: 'pointer' }}
          coords="470,149,703,222"
          shape="rect"
        />
      </map>

      <map name="image-map">
        <area
          alt="예매"
          title="예매"
          onClick={() => {
            // history.push('/reserve');
            _reserve();
          }}
          style={{ cursor: 'pointer' }}
          coords="526,117,1191,227"
          shape="rect"
        />
        <area
          target=""
          alt="전시정보"
          title="전시정보"
          href="#info"
          coords="366,225,84,120"
          shape="rect"
        />
        <area
          target=""
          alt="예매정보"
          title="예매정보"
          onClick={() => {
            _reserveList();
          }}
          style={{ cursor: 'pointer' }}
          coords="1629,224,1307,122"
          shape="rect"
        />
      </map>
      {/* <div style={{ backgroundColor: '#fff' }}>
        <div onClick={_reserve}>예매하기</div>
        <div onClick={_reserveList}>예매목록</div>
      </div> */}
    </>
  );
};

export default shopContext(withRouter(Ticket));
